import { Box, Grid, Typography, Card, CardContent } from "@mui/material";
import { baseUrl } from "../../utils/baseUrl";

const GroupedGrid = ({ groupedData }) => {
  return (
    <Box>
      {Object.keys(groupedData).map((zone) => (
        <Box key={zone} sx={{ marginBottom: 2 }}>
          <Typography fontWeight="bold" gutterBottom>
            {zone.toUpperCase()}
          </Typography>

          <Grid container spacing={2}>
            {groupedData[zone].map((item, index) => (
              <Grid item xs={6} sm={3} key={index} sx={{ display: "flex" }}>
                <Card
                  sx={{
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <CardContent
                    sx={{
                      flexGrow: 1,
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                    }}
                  >
                    <img
                      src={`${baseUrl}/g${item?.frontViewImage}`}
                      alt={item.name}
                      width={"70px"}
                    />

                    <Typography sx={{ mt: 1 }}>{item.name}</Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>
      ))}
    </Box>
  );
};

export default GroupedGrid;
